import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import VendorTopHead from './vendormasters-top-head';
import VendorContent from './vendormasters-content';
import VendorAddEdit from './vendormasters-add-edit';
import { actions as vendorsAction } from './store/slice';

const { resetFilters } = vendorsAction;

const VendorView = () => {
  const dispatch = useDispatch();
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingVendor, setEditingVendor] = useState(null);

  const handleShowAddModal = () => {
    setEditingVendor(null);
    setShowAddModal(true);
  };

  const handleHideModal = () => {
    setShowAddModal(false);
    setEditingVendor(null);
  };

  const handleEditVendor = (vendor) => {
    setEditingVendor(vendor);
    setShowAddModal(true);
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">Vendor Masters</h3>
              </div>
            </div>
          </div>
          <VendorTopHead onShowAddModal={handleShowAddModal} />
          <VendorContent onEditVendor={handleEditVendor} />
          <VendorAddEdit 
            show={showAddModal} 
            onHide={handleHideModal} 
            vendorData={editingVendor} 
          />
        </div>
      </div>
    </div>
  );
};

export default VendorView;